import { DashboardSSHKeys } from '@/pages/DashboardSSHKeys'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$orgId/dashboard/sshkeys')({
  component: DashboardSSHKeys,
  meta: () => [{ title: 'SSH Keys' }],
})
